import React from 'react'
import DefaultDashboard from '../../../Components/Dashboard/Default'
import { useAuth } from '../../../Context/AuthContext';
import { Card, CardBody, Container, Row, Col } from 'reactstrap';
import { ShieldOff } from 'react-feather';
import { H3, P } from '../../../AbstractElements';

export default function Default() {
  const { hasPermission } = useAuth();

  if (!hasPermission('dashboard.view')) {
    return (
      <div className='page-body'>
        <Container fluid>
          <Row className="justify-content-center align-items-center" style={{ minHeight: '70vh' }}>
            <Col md={6} lg={5} className="text-center">
              <Card className="border-0 shadow-lg" style={{ borderRadius: '20px', overflow: 'hidden' }}>

                <CardBody className="p-5">
                  <H3 className="fw-bold text-dark mb-3">Access Restricted</H3>
                  <P className="text-muted mb-4 px-4" style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                    You don't have the necessary administrative privileges to view the dashboard metrics.
                    Please contact your system administrator if you believe this is an error.
                  </P>
                  <div className="d-flex justify-content-center">
                    <div style={{ height: '4px', width: '60px', backgroundColor: 'primary', borderRadius: '2px' }}></div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div className='page-body'>
      <DefaultDashboard />
    </div>
  )
}